export default "__VITE_ASSET__Cj5MEL_C__"